import jQuery from 'jquery';
import objectFitImages from 'object-fit-images';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import 'Includes/browser-detect';
import 'Includes/jquery.rwdImageMaps';

(function($){
    $('img[usemap]').rwdImageMaps();

    $(window).on('scroll',function(){
        let posY = $(window).scrollTop();
        let all_height = document.documentElement.scrollHeight;
        let view_height = window.innerHeight;
        let av_height = all_height - view_height;
        if(posY > 10){
            if(av_height <= 500) return true;
            $('body').addClass('fixed');
        }else{
            $('body').removeClass('fixed');
        }
    });

    $(".hamburger").on('click',function(){
        let is_active = $(this).hasClass('is-active');
        let $_label = $(".header__hamburgers_label");
        let $spmenu = $(".spmenu");
        if(is_active){
            $(this).removeClass('is-active');
            $_label.removeClass('is-active').text('MENU');
            $spmenu.removeClass('active');
            clearAllBodyScrollLocks();
        }else{
            $(this).addClass('is-active');
            $_label.addClass('is-active').text('CLOSE');
            $spmenu.addClass('active');
            disableBodyScroll($spmenu);
        }
    });

    if(_uac.isMobile){
        $('.ste_tel_link').each(function (index, value) { 
            let strTel = $(this).text(); 
			let strTel2 = strTel.replace(/[^0-9]/ig, ""); // removes non numeric characters
			var telAnchor = $("<a>").attr("href", "tel:"+strTel2).text(strTel);
            $(this).html(telAnchor);
        });
    }

    objectFitImages('img.ofi');

    //URLのハッシュ値を取得
	var urlHash = location.hash;
	//ハッシュ値があればページ内スクロール
	if(urlHash) {
	  //スクロールを0に戻す
	//   $('body,html').stop().scrollTop(0);
	  setTimeout(function () {
		//ロード時の処理を待ち、時間差でスクロール実行
		scrollToAnker(urlHash) ;
	  }, 100);
	}

	$('a[href^="#"] , a[href^="/#"]').not('.fl-button').on('click',function(){
		if($(this).is('.header__mobile_nav,.mm-next,.mm-btn')){
			return true;
		}
		var href= $(this).attr("href").replace(/\//g, '');
		var target = $(href == "#" || href == "" ? 'html' : href);
		if(target.length){
			scrollToAnker(target);
			return false;
		}
    });

    function scrollToAnker(hash) {
        // var wid = $(window).width();
        // if(wid > 1000){
        //     var target = $(hash);
        //     var headerHeight = $(".header").outerHeight();
		// 	var position = target.offset().top - headerHeight;
        //     $('body,html').stop().animate({scrollTop:position}, 500);
        // }else{
        //     var target = $(hash);
        //     var position = target.offset().top;
        //     $('body,html').stop().animate({scrollTop:position}, 500);
        // }

        var target = $(hash);
        var position = target.offset().top;
        $('body,html').stop(true).animate({scrollTop:position}, 500);
    }

    //トップへ戻る
    let topBtn=$('.pagetop');
    topBtn.hide();

    let scrollHeight = $(document).height(); //ドキュメントの高さ 
    let footHeight = $(".footer").innerHeight(); //footerの高さ（＝止めたい位置）

    $(window).on('scroll',function(){
        let scrollPosition = $(window).height() + $(window).scrollTop(); //現在地 

        if($(this).scrollTop()>100){
            topBtn.fadeIn();
        }else{
            topBtn.fadeOut();
        }

        if ( scrollHeight - scrollPosition  <= footHeight ) {
            topBtn.removeClass('fixed');
        }else{
            topBtn.addClass('fixed');
        }
    });
    // ◇ボタンをクリックしたら、スクロールして上に戻る
    // topBtn.click(function(){
    //   $('body,html').animate({
    //   scrollTop: 0},500);
    //   return false;
    // });
})(jQuery);